// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database"; // Add this line
import { logEvent } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA7vFMDB5LoDsaU6upk6vuYHXtJ5bsL5U8",
  authDomain: "db-homeschool.firebaseapp.com",
  databaseURL: "https://db-homeschool-default-rtdb.firebaseio.com",
  projectId: "db-homeschool",
  storageBucket: "db-homeschool.firebasestorage.app",
  messagingSenderId: "995211285498",
  appId: "1:995211285498:web:4f1b8f233fc41315528a43",
  measurementId: "G-NZK3GKJ3LK",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const storage = getStorage(firebaseApp);

let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(firebaseApp);
}

if (analytics) {
  logEvent(analytics, "test_event");
}
const auth = getAuth(firebaseApp);
const database = getDatabase(firebaseApp); // Initialize Firebase Realtime Database

auth.onIdTokenChanged(async (user) => {
  if (user) {
    const newToken = await user.getIdToken();
    document.cookie = `token=${newToken}; path=/;`;
  }
});

async function getUser(token) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_REACT_APP_SERVER}/users/self`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) reject({ error: "Please sign in again" });

      const user = await response.json();
      resolve(user);
    } catch (error) {
      console.error("Error fetching user:", error);
      reject({ error: "Please sign in again" });
    }
  });
}

// Export the initialized modules
export { firebaseApp, analytics, auth, database, getUser, storage }; // Add 'database' to the export
